<template>
    <layout-main :banner="banner" subtitle="医废管理系统">
        <template v-slot:content>
            <p class="text">按照《医疗废物管理条例》（2003国务院第380号公布，2011年修订）、ISO14000环境管理体系标准，结合医院医疗废物管理的基本流程和管理难点，迪孚推出一系列全新的信息化管理系统。该系统替代了现医疗废物交接的书面记录方法，采取非接触式交接，通过手持终端对条形码的扫码交接，完成对医废从产生、收集到暂存点交接各个环节的无缝隙监管，涵盖整个医疗废物在院内流转的过程。</p>
            <p class="text">实现医院对每个医疗垃圾包、垃圾箱、垃圾回收人员以及回收车辆进行管控，通过对院内医疗废物全过程的监督管理，推进医疗废物在院内的收集、分类、包装、贮存等环节的信息化管理，使医院实现对医疗废物的监管规范化、系统化、科学化和现代化，提高监管的效率。</p>
            <img src="@/assets/medicalWaste/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 信息电子化：基于RFID和条形码识别技术，利用移动终端PDA，借助智能识别、移动计算技术，操作简便，仅需要扫描、确认，真正实现零输入、无纸质化，避免交叉感染和产生新的感染源。</p>
            <p class="text weight">· 责任明确：每个环节都需要通过手持终端扫描医疗废物袋上的条形码，扫描后就自动进入本环节，避免人为造成的疏忽和遗漏，责任明确</p>
            <p class="text weight">· 全程可追溯：各环节的科室、责任人、重量、时间等信息都可以随时查阅，达到全程可追溯的效果。</p>
            <p class="text weight">· 异常预警：报警功能动态监控院内/外各环节，及时发现问题并溯源，有效控制医疗废物非规范操作。</p>
            <p class="text weight">· 统计报表：可以统计出医疗废物操作人员的工作量，包括报警信息、异常数量，医院管理可以根据统计信息对医疗废物操作人员进行绩效考核。</p>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/assets/banner.png'
export default {
  components: {
      layoutMain,
      
  },
  data () {
      return {
          banner: banner
      }
  }
}
</script>
<style lang="scss" scoped>
.weight{
    font-weight: 600;
    line-height: 3 !important;
}
.title{ 
    text-indent: 1.5em;
    font-size: 25px;
    text-align: left;
    margin: 20px 0;
}
.text{
    line-height: 2;
}
.image1{
    width: 100%;
    margin: 50px 0;
}
</style>
